class FPProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-fp-carousel-track]');
    this.previousButton = this.querySelector('[data-fp-carousel-previous]');
    this.nextButton = this.querySelector('[data-fp-carousel-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.queueButtonUpdate, { passive: true });
    this.resizeObserver = new ResizeObserver(this.updateButtons);
    this.resizeObserver.observe(this.track);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.queueButtonUpdate);
    this.resizeObserver?.disconnect();
  }

  handlePrevious = () => this.scrollByCard(-1);
  handleNext = () => this.scrollByCard(1);

  queueButtonUpdate = () => window.requestAnimationFrame(this.updateButtons);

  scrollByCard(direction) {
    const card = this.track.querySelector('[data-fp-product-card]');
    if (!card) return;

    const styles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.track.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  updateButtons = () => {
    if (!this.track) return;

    const end = this.track.scrollWidth - this.track.clientWidth;
    this.toggleAttribute('data-has-overflow', end > 2);
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= end - 2;
  };
}

if (!customElements.get('fp-product-carousel')) {
  customElements.define('fp-product-carousel', FPProductCarousel);
}
